module.exports = __webpack_public_path__ + "static/media/fenouils.0c0c2a76.svg";